import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'
import ArrowIcon from 'core/components/icons/ArrowIcon'

const PostTable = props => {
  const { items } = props
  const q = new URLSearchParams(location.search)

  return (
    <table className="post-table">
      <tbody>
        <tr className="post-table-row mod-header">
          <th
            id="name"
            className={`post-table-cell type-body mod-ui mod-sort ${
              q.get('sort') === 'name' ? 'is-active' : ''
            }`}
            onClick={e => props.toggleSort(e)}
          >
            Name
            <span className={`post-table-order mod-${q.get('order')}`}></span>
          </th>

          <th
            id="type"
            className={`post-table-cell type-body mod-ui mod-sort ${
              q.get('sort') === 'type' ? 'is-active' : ''
            } `}
            onClick={e => props.toggleSort(e)}
          >
            Type
            <span className={`post-table-order mod-${q.get('order')}`}></span>
            <button
              className={`post-table-filter ${q.get('filter') === 'type' ? 'is-active' : ''}`}
              onClick={e => props.toggleFilter(e)}
            ></button>
          </th>

          <th
            id="location"
            className={`post-table-cell type-body mod-ui mod-sort ${
              q.get('sort') === 'location' ? 'is-active' : ''
            }`}
            onClick={e => props.toggleSort(e)}
          >
            Location
            <span className={`post-table-order mod-${q.get('order')}`}></span>
            <button
              className={`post-table-filter ${q.get('filter') === 'location' ? 'is-active' : ''}`}
              onClick={e => props.toggleFilter(e)}
            ></button>
          </th>

          <th
            id="year"
            className={`post-table-cell type-body mod-ui mod-sort ${
              q.get('sort') === 'year' ? 'is-active' : ''
            }`}
            onClick={e => props.toggleSort(e)}
            colSpan="2"
          >
            Year
            <span className={`post-table-order mod-${q.get('order')}`}></span>
            <button
              className={`post-table-filter ${q.get('filter') === 'year' ? 'is-active' : ''}`}
              onClick={e => props.toggleFilter(e)}
            ></button>
          </th>
        </tr>

        {items.map(item => (
          <tr key={item.ID} className="post-table-row">
            <td className="post-table-cell type-body mod-md-body">
              <Link
                to={`/project/${item.post_name}`}
                className="post-table-title type-heading mod-md-head"
              >
                {item.post_title}
              </Link>
            </td>

            <td
              data-id="type"
              className="post-table-cell type-body mod-md-body mod-filter"
              onClick={e => props.toggleFilter(e)}
            >
              {item.terms.project_type && item.terms.project_type[0].name}
            </td>

            <td
              data-id="location"
              className="post-table-cell type-body mod-md-body mod-filter"
              onClick={e => props.toggleFilter(e)}
            >
              {item.terms.project_location && item.terms.project_location[0].name}
            </td>

            <td
              data-id="year"
              className="post-table-cell type-body mod-md-body mod-filter"
              onClick={e => props.toggleFilter(e)}
            >
              {item.post_date.slice(0, 4)}
            </td>

            <td className="post-table-cell type-body mod-md-body">
              <Link to={`/project/${item.post_name}`} className="post-table-view-link">
                View
                <ArrowIcon />
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

PostTable.propTypes = {
  items: PropTypes.array.isRequired,
  toggleFilter: PropTypes.func,
  toggleSort: PropTypes.func
}

export default PostTable
